import React from 'react';
import Logo from '../../images/logo.jpeg';
import "../../styles/GoogleReviews.css";
import AutoScrollSection from "../../common/AutoScrollSection";


const reviews = [
  {
    name: "Harshitha N K",
    time: "1 year ago",
    text: "It's an amazing services by Sujaramaha enterprises in all sector,",
  },
  {
    name: "Rakesh S",
    time: "1 year ago",
    text: "One of the trusted Agency.. most recommended.",
  },
  {
    name: "Krupachar K V",
    time: "8 months ago",
    text: "Highly recommended! Sujaramaha Enterprises delivers exceptional service with a strong focus on professionalism and reliability. From the first interaction to the final delivery, the team was responsive, knowledgeable, and efficient. It's clear they take pride in their work and value customer satisfaction. I wouldn’t hesitate to work with them again. Great experience overall!",
  },
  {
    name: "Anusha N K",
    time: "8 months ago",
    text: "It's very good service, friendly co ordination by team. cctv installation has been done in my home,Most recommended agency, very happy with services.",
  },
];

export default function GoogleReviews() {
  return (
    <section className="google-reviews-section">
      <h2>Customer Reviews</h2>

      <div className="google-reviews-row">
        {/* LEFT FIXED PANEL */}
        <div className="google-review-summary">
          <img
            src={Logo}
            alt="Business"
          />
          <h3>Sujaramaha Enterprises</h3>
          <div className="stars">★★★★★</div>
          <p>524 Google reviews</p>

          <a
            href="https://g.page/r/CZspWLvU7AbXEBM/review"
            target="_blank"
            rel="noreferrer"
            className="write-review-btn"
          >
            Write a review
          </a>
        </div>

        {/* RIGHT MOVING REVIEWS */}
              <div className="google-reviews-marquee">
                  <AutoScrollSection>
          <div className="google-reviews-track">
                          {/* {[...reviews, ...reviews].map((r, i) => (*/}
               {reviews.map((r, i) => (
              <div className="google-review-card" key={i}>
                <div className="review-header">
                  <div className="avatar">{r.name.charAt(0)}</div>

                  <div>
                    <strong>{r.name}</strong>
                    <span>{r.time}</span>
                  </div>

                  <img
                    src="https://www.gstatic.com/images/branding/product/1x/gsa_64dp.png"
                    alt="Google"
                    className="google-icon"
                  />
                </div>

                <div className="stars">★★★★★</div>
                <p>{r.text}</p>
              </div>
            ))}
                      </div>
                  </AutoScrollSection>
        </div>
          </div>
      
    </section>
  );
}
